import React, { memo, Suspense } from 'react';
import { ConfigProvider } from 'antd';
import trTR from 'antd/lib/locale/tr_TR';
import enUS from 'antd/lib/locale/en_US';
import { BrowserRouter } from 'react-router-dom';
import { ApiProvider, CustomDialogProvider, LoadingImage } from '@src/components';
import { useLang } from '@src/context';
import { languageOptions } from '@src/assets/language';
import Router from './Router';
import 'swiper/css/bundle';

const App = () => {
  const { language } = useLang();

  return (
    <ConfigProvider locale={language === languageOptions.english ? enUS : trTR}>
      <BrowserRouter basename={'/'}>
        <ApiProvider>
          <CustomDialogProvider />
          <Suspense fallback={<LoadingImage />}>
            <Router />
          </Suspense>
        </ApiProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default memo(App);
